import FirebaseContext from './context';
import Firebase from './firebase';
import translateErrorMessage from './TranslateErrorMessage'

export default Firebase

export { FirebaseContext, translateErrorMessage }
